/**
 * Generates a short Swedish description for a place based on available metadata.
 * Used as fallback when admin doesn't provide a custom description.
 *
 * @returns A non-empty string, max ~160 characters
 */
export function buildDescriptionShort(input: {
  name: string;
  tags?: string[];
  municipality?: string | null;
  county?: string | null;
  landskap?: string | null;
}): string {
  const { name, tags = [], municipality, county, landskap } = input;

  // Determine type label from tags
  const TAG_LABELS: Record<string, string> = {
    gårdsbutik: "gårdsbutik",
    café: "café",
    restaurang: "restaurang",
    boende: "boende",
    camping: "camping",
    vingård: "vingård",
    bryggeri: "bryggeri",
    butik: "butik",
  };

  let typeLabel = "plats";
  for (const tag of tags) {
    if (TAG_LABELS[tag]) {
      typeLabel = TAG_LABELS[tag];
      break;
    }
  }

  // Build location string
  const locationParts: string[] = [];
  if (municipality?.trim()) locationParts.push(municipality.trim());
  if (landskap?.trim()) {
    locationParts.push(landskap.trim());
  } else if (county?.trim()) {
    locationParts.push(county.trim());
  }

  const suffix = "Upptäck platsen och vad den har att erbjuda.";

  if (locationParts.length > 0) {
    return `${name} – ${typeLabel} i ${locationParts.join(", ")}. ${suffix}`;
  }

  return `${name} – ${typeLabel}. ${suffix}`;
}
